import elementExists from './elementExists';

const pauseVideos = function (source) {
  const videos = source.querySelectorAll('video');
  if (elementExists(videos)) {
    videos.forEach((video) => video.pause());
  }
  const iframes = source.querySelectorAll('iframe');
  if (elementExists(iframes)) {
    iframes.forEach((iframe) => {
      const src = iframe.getAttribute('src');
      iframe.setAttribute('src', '');
      iframe.setAttribute('src', src);
    });
  }
};

export default pauseVideos;
